import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getDurationInputTestIds = createTestIds('duration-input', [
  'control-hour',
  'control-minute',
  'control-second',
  'control-number',
  'control-unit',
  ...elements
] as const);

export const getDateInputTestIds = createTestIds('date-input', [
  'control-day',
  'control-month',
  'control-year',
  'open-close-picker',
  'picker',
  'clear-current-date',
  'set-current-date',
  ...elements
] as const);

export const getDateRangeInputTestIds = createTestIds('date-range-input', [
  'from-date',
  'to-date',
  ...elements
] as const);

export const getDateTimeInputTestIds = createTestIds('date-time-input', [
  'control-day',
  'control-month',
  'control-year',
  'control-hour',
  'control-minute',
  'control-second',
  'control-period',
  'open-close-picker',
  'picker',
  'discard-changes',
  'apply-changes',
  'clear-current-date-and-time',
  'set-current-date-and-time',
  ...elements
] as const);

export const getDayOfWeekInputTestIds = createTestIds('day-of-week-input', [
  'control',
  ...elements
] as const);

export const getMonthInputTestIds = createTestIds('month-input', [
  'control-month',
  'control-year',
  ...elements
] as const);

export const getQuarterInputTestIds = createTestIds('quarter-input', [
  'control-quarter',
  'control-year',
  ...elements
] as const);

export const getTimeInputTestIds = createTestIds('time-input', [
  'control-hour',
  'control-minute',
  'control-second',
  'control-period',
  'open-close-picker',
  'picker',
  'clear-current-time',
  ...elements
] as const);

export const getTimeRangeInputTestIds = createTestIds('time-range-input', [
  'from-time',
  'to-time',
  'from-date-time',
  'to-date-time',
  ...elements
] as const);

export const getWeekInputTestIds = createTestIds('week-input', [
  'control-week',
  'control-year',
  'open-close-picker',
  'picker',
  'clear-current-week',
  ...elements
] as const);

export const getDatePickerTestIds = createTestIds('date-picker', [
  'previous-month',
  'month',
  'next-month',
  'calendar',
  'time',
  'set-current-date'
] as const);
